import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const SpeedingPage = lazy(() => import('@cobliteam/speeding'));

const routes = [
  {
    path: Location.SPEEDING,
    component: SpeedingPage,
    accessDeniedDescription: 'ver eventos de velocidade',
  },
];

export default routes;
